export enum EnumEmployeeDelegationMode {
  ALL = "ALL",
  CHOOSE = "CHOOSE",
}
